<template>
    <div class="content">
        <el-form
            :label-position="labelPosition"
            label-width="80px"
            :model="formLabelAlign"
            ref="formLabelAlign"
            :rules="formLabelRules"
        >
            <el-form-item label="标题" prop="title">
                <el-input v-model="formLabelAlign.title"></el-input>
            </el-form-item>
            <el-form-item label="内容" prop="body">
                <el-input
                    type="textarea"
                    autosize
                    placeholder="请输入内容"
                    v-model="formLabelAlign.body"
                >
                </el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="formLabelAlign.phone"></el-input>
            </el-form-item>
            <el-button
                :loading="loading"
                type="primary"
                style="
                    width: 100%;
                    margin-top: 35px;
                    background: #0195ff;
                    box-shadow: 0 2px 9px 0 #0195ff33;
                    border-radius: 8px;
                "
                @click.native.prevent="submit"
                >提交</el-button
            >
        </el-form>
    </div>
</template>

<script>
import { pushQuestion } from '@/api/index'
export default {
    data() {
        return {
            labelPosition: 'top',
            formLabelAlign: {
                title: '',
                body: '',
                phone: ''
            },
            formLabelRules: {
                title: [
                    {
                        required: true,
                        trigger: 'blur',
                        message: '请输入问题标题'
                    }
                ],
                body: [
                    {
                        required: true,
                        trigger: 'blur',
                        message: '请输入问题内容'
                    }
                ],
                phone: [
                    {
                        required: true,
                        trigger: 'blur',
                        message: '请输入联系方式'
                    }
                ]
            }
        }
    },
    methods: {
        submit() {
            this.$refs.formLabelAlign.validate((valid) => {
                if (valid) {
                    this.loading = true
                    pushQuestion(this.formLabelAlign).then((response) => {
                        this.loading = false
                        console.log(response)
                        if (response.code == 0) {
                            this.$message({
                                message: '提交成功',
                                type: 'success'
                            })
                            this.formLabelAlign = {
                                title: '',
                                body: '',
                                phone: ''
                            }
                        }
                    })

                    // this.$store
                    //     .dispatch('user/login', this.loginForm)
                    //     .then(() => {
                    //         this.$router.push({ path: this.redirect || '/' })
                    //         this.loading = false
                    //     })
                    //     .catch(() => {
                    //         this.loading = false
                    //     })
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    padding: 30px;
    box-sizing: border-box;
}
</style>